module.exports = __webpack_public_path__ + "assets/img/title-download-method-1e40f4ae.png";